var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-content-loading",
    {
      attrs: {
        height: 560,
        width: 785,
        speed: 2,
        "primary-color": "#f3f3f3",
        "secondary-color": "#ecebeb",
      },
    },
    [
      _c("rect", {
        attrs: {
          x: "18",
          y: "17.73",
          rx: "5",
          ry: "5",
          width: "279.4",
          height: "12.7",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "27.34",
          y: "88.27",
          rx: "0",
          ry: "0",
          width: "267",
          height: "8",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "316.34",
          y: "88.27",
          rx: "0",
          ry: "0",
          width: "401",
          height: "8",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "27.34",
          y: "121.27",
          rx: "0",
          ry: "0",
          width: "313",
          height: "8",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "350.34",
          y: "121.22",
          rx: "0",
          ry: "0",
          width: "349",
          height: "8",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "33.34",
          y: "152.27",
          rx: "0",
          ry: "0",
          width: "688",
          height: "8",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "35.34",
          y: "184.27",
          rx: "0",
          ry: "0",
          width: "255",
          height: "8",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "309.34",
          y: "184.27",
          rx: "0",
          ry: "0",
          width: "404",
          height: "8",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "25",
          y: "233.73",
          rx: "5",
          ry: "5",
          width: "279.4",
          height: "12.7",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "341",
          y: "232.73",
          rx: "5",
          ry: "5",
          width: "279.4",
          height: "12.7",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "28.34",
          y: "280.27",
          rx: "0",
          ry: "0",
          width: "680",
          height: "8",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }